import { Component, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    imports: [RouterModule],
    templateUrl: './chatSupport.component.html',
    styleUrl: './chatSupport.component.scss'
})
export class ChatSupportComponent implements OnInit {
  ngOnInit() {}

  ngAfterViewInit() {
    const element = document.querySelector(
      '[data-selector=GUIDE_CHANNEL_BUTTON]',
    ) as HTMLElement;

    element.style.visibility = 'visible';
    if (element) {
      element.click();
    }
  }
}
